import React from 'react';

const getStatusColor = (status) => {
  switch (status?.toLowerCase?.()) {
    case 'altcoin season':
      return 'text-green-500';
    case 'bitcoin season':
      return 'text-red-500';
    case 'neutral':
      return 'text-yellow-500';
    default:
      return 'text-gray-500';
  }
};

const AltcoinSeasonIndicator = ({ score, status }) => {
  return (
    <div className="flex items-center whitespace-nowrap">
      <span className="mr-1 font-medium lg:hidden">Altseason:</span>
      <span className="mr-2 font-medium hidden lg:inline">Altcoin Season:</span>
      <a 
        href="https://www.blockchaincenter.net/en/altcoin-season-index/"
        target="_blank"
        rel="noopener noreferrer"
        className={`${getStatusColor(status)}`}
      >
        <span className={`font-bold ${getStatusColor(status)} mr-1`}>
            {score ?? 'N/A'}%
        </span>
        <span className={`hidden lg:inline text-xs ${getStatusColor(status)}`}>
          ({status || 'Unknown'})
        </span>
      </a>
    </div>
  );
};

export default AltcoinSeasonIndicator; 